import { Metric } from '../../../../dashboard-config/dashboard-config.model';
import {
  expandProductCatalog,
  ProductCatalogEntry,
} from '../../../_shared/dashboard-definition.model';
import { createDashboardForecastComparisonDefinition } from './create-dashboard-forecast-comparison-definition';
import {
  ForecastComparisonMetricProfile,
  forecastCompaniesCountProfile,
  forecastCompaniesRevenueProfile,
  forecastEconomicParticipantProfile,
  forecastEmployedProfile,
} from '../forecast-metric.profile';
import { DashboardForecastComparisonShell } from './dashboard-forecast-comparison-shell.profile';
import { DashboardForecastComparisonDefinition } from './dashboard-forecast-comparison.definition';

/**
 * Product catalog for forecast comparison dashboards.
 * Shell/metric profiles own behavior (incl. bundesvergleich-WZ dataset geo).
 * Identity is derived in {@link createDashboardForecastComparisonDefinition}.
 */

// Pending datasets: Tourism, SelfEmployed and GrossValueAdded forecasts.
type ForecastComparisonMetric = Exclude<
  Metric,
  Metric.Tourism | Metric.SelfEmployed | Metric.GrossValueAdded
>;

const FORECAST_COMPARISON_SHELLS: readonly DashboardForecastComparisonShell[] = [
  'bundesvergleichTeilmarkte',
  'bundesvergleichWzKlassen',
  'marktvergleichTeilmarkte',
  'marktvergleichWzKlassen',
];

export const FORECAST_COMPARISON_PRODUCT_CATALOG: Record<
  ForecastComparisonMetric,
  ProductCatalogEntry<
    ForecastComparisonMetricProfile,
    DashboardForecastComparisonShell
  >
> = {
  [Metric.CompaniesCount]: {
    metric: forecastCompaniesCountProfile,
    shells: FORECAST_COMPARISON_SHELLS,
  },
  [Metric.CompaniesRevenue]: {
    metric: forecastCompaniesRevenueProfile,
    shells: FORECAST_COMPARISON_SHELLS,
  },
  [Metric.EconomicParticipant]: {
    metric: forecastEconomicParticipantProfile,
    shells: FORECAST_COMPARISON_SHELLS,
  },
  [Metric.Employed]: {
    metric: forecastEmployedProfile,
    shells: FORECAST_COMPARISON_SHELLS,
  },
};

/** All forecast comparison product definitions. */
export const FORECAST_COMPARISON_DEFINITIONS: DashboardForecastComparisonDefinition[] =
  expandProductCatalog(
    Object.values(FORECAST_COMPARISON_PRODUCT_CATALOG),
    createDashboardForecastComparisonDefinition,
  );
